export { CodeSyntaxHighlighter as SyntaxHighlighter } from '@onefootprint/ui';

// Maps highlight.js token classes onto the DS hljs CSS variables. Same mapping
// as the standalone `CodeBlock` component in `@onefootprint/ui`, kept inline
// here so the chat surface can render expanded tool results with tighter
// padding than that component allows.
export const HLJS_TOKEN_STYLE = {
  'hljs-comment': { color: 'var(--hljs-comment-color)', fontStyle: 'var(--hljs-comment-font-style)' },
  'hljs-keyword': { color: 'var(--hljs-keyword-color)' },
  'hljs-section': { color: 'var(--hljs-section-color)' },
  'hljs-name': { color: 'var(--hljs-name-color)' },
  'hljs-selector-tag': { color: 'var(--hljs-selector-tag-color)' },
  'hljs-subst': { color: 'var(--hljs-subst-color)' },
  'hljs-literal': { color: 'var(--hljs-literal-color)' },
  'hljs-string': { color: 'var(--hljs-string-color)' },
  'hljs-regexp': { color: 'var(--hljs-regexp-color)' },
  'hljs-attribute': { color: 'var(--hljs-attribute-color)' },
  'hljs-built_in': { color: 'var(--hljs-built-in-color)' },
  'hljs-attr': { color: 'var(--hljs-attr-color)' },
  'hljs-variable': { color: 'var(--hljs-variable-color)' },
  'hljs-template-variable': { color: 'var(--hljs-template-variable-color)' },
  'hljs-type': { color: 'var(--hljs-type-color)' },
  'hljs-number': { color: 'var(--hljs-number-color)' },
  'hljs-symbol': { color: 'var(--hljs-symbol-color)' },
  'hljs-bullet': { color: 'var(--hljs-bullet-color)' },
  'hljs-link': { color: 'var(--hljs-link-color)', textDecoration: 'var(--hljs-link-text-decoration)' },
  'hljs-meta': { color: 'var(--hljs-meta-color)' },
  'hljs-title': { color: 'var(--hljs-title-color)' },
  'hljs-class .hljs-title': { color: 'var(--hljs-class-title-color)' },
  'hljs-selector-id': { color: 'var(--hljs-selector-id-color)' },
  'hljs-selector-class': { color: 'var(--hljs-selector-class-color)' },
  'hljs-selector-attr': { color: 'var(--hljs-selector-attr-color)' },
  'hljs-selector-pseudo': { color: 'var(--hljs-selector-pseudo-color)' },
  'hljs-addition': { color: 'var(--hljs-addition-color)' },
  'hljs-deletion': { color: 'var(--hljs-deletion-color)' },
  'hljs-emphasis': { fontStyle: 'var(--hljs-emphasis-font-style)' },
  'hljs-strong': { fontWeight: 'var(--hljs-strong-font-weight)' },
};
